import { each } from '@antv/util';
import { BBox, IGroup, IShape } from '../../../dependents';
import { translate } from '../../../util/transform';
import { LabelItem } from '../interface';

/**
 * @ignore
 * å° label éå¶å¨ç»å¸èå´åï¼ç®åå¾å°è¶åºç»å¸ç label å¾ç»å¸åè°æ´
 * @param labels
 * @param cfg
 */
export function limitInCanvas(items: LabelItem[], labels: IGroup[], shapes: IShape[] | IGroup[], region: BBox) {
  each(labels, (label: IGroup) => {
    const { minX: regionMinX, minY: regionMinY, maxX: regionMaxX, maxY: regionMaxY } = region;
    const { minX, minY, maxX, maxY, x, y, width, height } = label.getCanvasBBox();

    let finalX = x;
    let finalY = y;
    if (minX < regionMinX || maxX < regionMinX) {
      // è¶åºå·¦ä¾§
      finalX = regionMinX;
    }
    if (minY < regionMinY || maxY < regionMinY) {
      // è¶åºé¡¶é¨
      finalY = regionMinY;
    }

    if (minX > regionMaxX) {
      // æ´ä½è¶åºå³ä¾§
      finalX = regionMaxX - width;
    } else if (maxX > regionMaxX) {
      // è¶åºå³ä¾§
      finalX = finalX - (maxX - regionMaxX);
    }

    if (minY > regionMaxY) {
      // æ´ä½è¶åºé¡¶é¨
      finalY = regionMaxY - height;
    } else if (maxY > regionMaxY) {
      // è¶åºåºé¨
      finalY = finalY - (maxY - regionMaxY);
    }

    if (finalX !== x || finalY !== y) {
      translate(label, finalX - x, finalY - y);
    }
  });
}
